export default __webpack_public_path__ + "static/media/photo-3.b8ff2db2.jpg";